import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimExportElementView extends IModelBase {
  Value1: string
  Value2: string
  Value3: string
  Value4: string
  Value5: string
  Value6: string
  Value7: string
  Value8: string
  Value9: string
  Value10: string
  Value11: string
  Value12: string
  Value13: string
  Value14: string
  Value15: string
  Value16: string
  Value17: string
  Value18: string
  Value19: string
  Value20: string
  ClaimId: number
  Raw837FileId: number
  TemplateSegmentId: number
  ClaimExportId: number
  ClaimStringId: string
}

@Injectable()
export class ClaimExportElementViewODataService extends ODataService<IClaimExportElementView> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimExportElementView'
  }
}
